import React from "react";

function Footer() {
  return (
    <footer className="tc-footer-style1">
      <div className="container">
        <div className="top-content py-5">
          <div className="row gx-0">
            <div className="d-flex justify-content-center align-items-center">
              <div className="info-side">
                <div className="foot-social">
                  {/* <a href="#">
                    <i className="fab fa-x-twitter"></i>
                  </a> */}
                  <a
                    href="https://www.facebook.com/share/1AuBbr8NV7/?mibextid=LQQJ4d"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/tameer_construction/profilecard"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  {/* <a href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-youtube"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row">
            <div className="col-lg-6">
              <p className="fsz-13">© 2025 تعمير. جميع الحقوق محفوظة</p>
            </div>
            <div className="col-lg-6">
              <div className="foot-links mt-4 mt-lg-0">
                <a href="#home"> الرئيسية </a>
                <a href="#about"> من نحن </a>
                <a href="#services"> خدماتنا </a>
                <a href="#process"> منهجنا </a>
                <a href="#projects"> المشاريع </a>
                <a href="#contact"> اتصل بنا </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
